

export const ColorPalette_NavigationBG_Dark = {
    'blue'      : '#274182',
    'violet'    : '#423271',
    'green'     : '#135B24',
    'turquoise' : '#00596c',
    'dark'      : '#272F39',
}

export const ColorPalette_NavigationBGDark_Dark = { // border
    'blue'      : '#1c2f5e',
    'violet'    : '#2e234f',
    'green'     : '#0c3b16',
    'turquoise' : '#003844',
    'dark'      : '#161a1f',
}

export const ColorPalette_NavigationSelected_Dark = {
    'blue'      : '#203977',
    'violet'    : '#3a2c64',
    'green'     : '#104F1F',
    'turquoise' : '#004d5e',
    'dark'      : '#1f2833',
}
